import { Component } from '@angular/core';

@Component({
    selector: 'changelog-dialog',
    templateUrl: './changelog-dialog.component.html',
    styleUrls: ['./changelog-dialog.component.scss'],
})
export class ChangelogDialogComponent {}
